import styled, { css } from 'styled-components';

import { CommonAction, extCommonAction, recipesCommonAction, styledReset, styledTypography } from '@pkg/primitives';

import { type PayActionSize } from './PayActions.types';

import { tokens } from './PayActions.tokens';

interface StyledPayActionsProps {
    $size?: PayActionSize;
}

interface ActionProps {
    $highlight?: boolean;
}

export const StyledPayActions = styled.div<StyledPayActionsProps>`
    ${styledReset.borderBox};

    --pay-actions-gap: ${({ $size = 'medium' }) => tokens.gap[$size]}px;
    --pay-actions-padding: ${({ $size = 'medium' }) => tokens.action.padding[$size]}px;
    --pay-actions-height: ${({ $size = 'medium' }) => tokens.action.height[$size]}px;
    --pay-actions-font-size: ${({ $size = 'medium' }) => tokens.label.size[$size]}px;

    display: grid;
    gap: var(--pay-actions-gap);
`;

const actionTransitionProps = [...extCommonAction.transitionProps, 'height', 'font-size'];

// TODO: Determine if we need to support a "link".
export const Action = styled(CommonAction)<ActionProps>`
    ${recipesCommonAction.basic};
    padding-left: var(--pay-actions-padding);
    padding-right: var(--pay-actions-padding);
    width: 100%;
    transition-property: ${actionTransitionProps.join(',')};

    ${({ $highlight }) => {
        const alphaFactor = $highlight ? 1 : 0.6;
        const scaleFactor = $highlight ? 1 : 0.8;

        return css`
            color: rgb(255, 255, 255, ${alphaFactor});
            height: calc(var(--pay-actions-height) * ${scaleFactor});
            font-size: calc(var(--pay-actions-font-size) * ${scaleFactor});
        `;
    }};

    &:disabled {
        opacity: 0.6;
    }

    &:active {
        opacity: 0.9;
    }

    // Crypto action
    &:first-child {
        ${extCommonAction.gradientRadical};
        ${extCommonAction.afterGlowRadical};

        &::before,
        &::after {
            opacity: ${({ $highlight }) => ($highlight ? 1 : 0.6)};
        }
    }

    // Credit card action
    &:last-child {
        ${extCommonAction.gradientPrimary};
        ${extCommonAction.afterGlowPrimary};

        &::before,
        &::after {
            opacity: ${({ $highlight }) => ($highlight ? 1 : 0)};
        }
    }
`;

export const Label = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    z-index: 2;
    position: relative;
    display: block;
    font-size: 1em;
    font-weight: 700;
    color: currentColor;
`;
